
import CreateComboDialog from "../dialogs/menu-create-combo-dialog.vue";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";
export default {
  components: {
    CreateComboDialog,
    CreateEditAddonDialog
  },
  props: {
    tab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showCreateComboDialog: false,
      showCreateAddonDialog: false
    };
  },
  methods: {
    handleClick() {
      switch (this.tab) {
        case 0:
          this.$router.push("/menu/new/item");
          break;

        case 2:
          this.showCreateComboDialog = true;
          break;
        case 1:
          this.showCreateAddonDialog = true;
          break;
      }
    }
  }
};
